export interface RequestCredentials {
  apiKey: string
  secret: string
}

// Per-request credential isolation. The module-level singleton (see ./credentials)
// is shared across every concurrent request handled by the same server instance,
// so mutating it per locale races. AsyncLocalStorage scopes the credentials to the
// current request's async context instead.
//
// `node:async_hooks` is server-only, but this module is still transitively reachable
// from client bundles: the storefront-modules/* barrels re-export their server `./api`
// handlers alongside client components, so a client component importing such a barrel
// drags in the `api` barrel and, with it, this module. Fully severing that would mean
// refactoring every module barrel. Instead we load the builtin via
// `process.getBuiltinModule` (Node >=22.3) behind a `typeof process` guard — this is
// invisible to the bundler, so the builtin never has to be resolved for the browser.
// On the client `store` is undefined and the setters/getters no-op.
const asyncHooks =
  typeof process !== 'undefined' ? process.getBuiltinModule?.('node:async_hooks') : undefined

const store = asyncHooks ? new asyncHooks.AsyncLocalStorage<RequestCredentials>() : undefined

// enterWith binds the credentials to the current request's async context, so
// concurrent requests for different markets never overwrite each other's values.
export const setRequestCredentials = (credentials: RequestCredentials): void =>
  store?.enterWith(credentials)

export const getRequestCredentials = (): RequestCredentials | undefined => store?.getStore()
